import { connect } from 'react-redux'
import { compose } from 'recompose'

import { activate as activateSearch } from 'data/search'
import { makeHoverable } from 'components/Utils/hoverable'
import { trackOpenQuickSwitch } from 'data/analytics/actions'

export default compose(
  makeHoverable(),
  connect(
    null,
    {
      onClick: () => {
        trackOpenQuickSwitch({ source: 'click' })
        return activateSearch()
      },
    }
  )
)
